import * as L from 'leaflet';

export function createLocationMarkerIcon(): L.DivIcon {
    const markerHtml = `
        <div class="current-location-marker-container">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_418_21092)">
                    <circle cx="20" cy="18" r="8" fill="white"/>
                    <circle cx="20" cy="18" r="5" stroke="#4F46E5" stroke-width="6"/>
                </g>
                <defs>
                    <filter id="filter0_d_418_21092" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feMorphology radius="4" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_418_21092"/>
                        <feOffset dy="2"/>
                        <feGaussianBlur stdDeviation="4"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_418_21092"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_418_21092" result="shape"/>
                    </filter>
                </defs>
            </svg>
        </div>
    `;

    return L.divIcon({
        html: markerHtml,
        className: 'custom-current-location-icon',
        iconSize: [40, 40],
        iconAnchor: [20, 40],
    });
}
